module.exports = __webpack_public_path__ + "static/garden_mock-871c332dbf5c2b11fd2d4c8348d9299b.png";